import { useCallback, useEffect, useState } from 'react'

import useCustomToast from '@/hooks/toasts'
import { getMaintenanceData } from '@/store/app/AppAtom'
import { IBanner } from '@/types/app/App'

const Container = () => {
    const [banners, setBanners] = useState<Array<IBanner>>([])
    const [activeItem, setActiveItem] = useState<IBanner>()

    const onClose = useCallback(() => {
        const copyBanners = [...banners]
        const newBannerArray = copyBanners.filter((item) => item.msgid !== activeItem?.msgid)
        if (newBannerArray.length > 0) {
            setActiveItem(newBannerArray[0])
        } else {
            setActiveItem(undefined)
        }

        setBanners(newBannerArray)

        // set on local storage already viewed banner to not show next time
        const localStorageBaners = localStorage.getItem('view-banner')
        if (localStorageBaners && activeItem) {
            const localBanners: Array<string> = JSON.parse(localStorageBaners) as Array<string>
            const checkIfExist = localBanners.findIndex((item) => item === activeItem.msgid)
            if (checkIfExist === -1) {
                localBanners.push(activeItem.msgid)
                localStorage.setItem('view-banner', JSON.stringify(localBanners))
            }
        } else if (activeItem) {
            localStorage.setItem('view-banner', JSON.stringify([activeItem.msgid]))
        }
    }, [activeItem, banners, setBanners])

    const [addToast] = useCustomToast(onClose)

    useEffect(() => {
        if (activeItem) {
            const localStorageBaners = JSON.parse(localStorage.getItem('view-banner') || '[]') as Array<string>
            const findItem = localStorageBaners.findIndex((item) => item === activeItem.msgid)
            findItem === -1 ? addToast('warning', activeItem.text, undefined, true) : onClose()
        } else if (banners.length > 0) {
            setActiveItem(banners[0])
        }
    }, [activeItem, banners, addToast, onClose])

    useEffect(() => {
        const getBannerData = async () => {
            const bannerInfo: Array<IBanner> = await getMaintenanceData()
            setBanners(bannerInfo)
            if (bannerInfo.length === 0) {
                localStorage.removeItem('view-banner')
            }
        }

        void getBannerData()
    }, [])

    return null
}

export default Container
